/**
 *  Constructor - see cpc zones-conf.js
 *
 *  themes = {
 *    'someField': {
 *      'val1': style1,
 *      'val2': style2
 *    }
 *  }
 *
 */

export default function(params) {
  let themes = params.themes || {};
  let changeHandler = params.changeHandler || function(field) {console.log(field)};
  this.thematicField = '';

  function getThematicField() {
    return this.thematicField;
  }

  function setThematicField(field) {
    this.thematicField = field;
    if (themes[field] === undefined) {
      themes[field] = {};
    }
    changeHandler(field);
  }

  /*
  // hard-wired, called only for nematode below
  function thematicRanges(feature, table, column) {
    var layer = feature.getLayer().get('title');
    console.log('thematic range layer:', layer);
    switch (layer) {
      case 'Sweetpotatoes':
        break;
      case 'Cucurbits (melons, cucumbers)':
        break;
      case 'Cucurbits (melons, cucumbers)':
        break;
      case 'Tobacco':
        break;
      case 'Peppers':
        break;
      case 'Peppers':
        break;
      case 'Cotton behind cotton':
        break;
      case 'Cotton behind crop other than cotton':
        break;
      case 'Cotton-stubby root':
        break;
      case 'Cotton-lesion':
        break;
      case 'Corn/sorghum':
        break;
      case 'Peanuts':
        break;
      case 'Soybeans':
        break;
      case 'Soybeans':
        break;
      case 'Broccoli/cole crops':
        break;
      default:
    }
  }
  */

  /*
    function getSampleYearAttrib(attrib, feature) {
      let indexOfSpace = attrib.indexOf(' ');
      if (indexOfSpace > 0 ) { // if there's a space then this is an attribute of a joined table _soils
        let tableName = attrib.substr(0, indexOfSpace);
        let attributeName = attrib.substr(indexOfSpace + 1);
        let table = feature.get(tableName) || [];
        let val = sampleYear.sampleBySampleYear(table, attributeName);
        // very similar to sampleYear.whichSample() below
        table.forEach(row => {
          if (row.sample_year == sampleYear.get()) {
            val = attributeName + ' ' + row[attributeName];
            // val = row[attributeName];
          }
        });
      }
    }
  */

  /*
   * called from LayerStyle.js:styleFunc()
   * works for unique classes
   */
  // function getThematicStyle(feature) {
  function getThematicFillColor(feature) {
    let val;
    let style = null;
    let fillcolor = null;
    if (this.thematicField) {
      if (this.thematicField.indexOf('_') === 0) {  // '_' indicates a joined table (possibly)
        let attrib = this.thematicField;
        let indexOfSpace = attrib.indexOf('-'); // Changed to hyphen 2020-04-02 for consistencey between _nematode and _soils
        if (indexOfSpace > 0 ) { // if there's a space then this is an attribute of a joined table _soils
          let tableName = attrib.substr(0, indexOfSpace);
          let attributeName = attrib.substr(indexOfSpace + 1);  // don't use split here because an attribute may have spaces in its name
          let table = feature.get(tableName) || [];
          // val = sampleYear.sampleBySampleYear(table, attributeName);
          // very similar to sampleYear.whichSample()
          table.forEach(row => {
            if (row.sample_year == sampleYear.get()) {
              // val = attributeName + ' ' + row[attributeName];
              val = row[attributeName];
            }
          });
        } else {
          // requested thematic on parent attribute of a joined table
          val = feature.get(this.thematicField) ? '*' : null;
        }

        // if (arr[0] === '_nematode') { // ranges w/ predefined colors rather than user assigned unique colors
        //   thematicRanges(feature, table, column);
        // }

      } else {
        val = feature.get(this.thematicField);
      }

      if (Array.isArray(themes[this.thematicField])) {  // thematic ranges of values
        themes[this.thematicField].forEach(e => {
          if(e[0] < val && val <= e[1]) {
            style = rwg.styles.makeStyle({
              fillColor: e[2],
              // stroke: true,
              text: feature.getProperties()['label']
            });
            fillcolor = e[2];
          }
        });
      } else if(typeof themes[this.thematicField] === 'function') {
        fillcolor = themes[this.thematicField](val)
      } else {   // thematic unique values
        if (val) {
          fillcolor = themes[this.thematicField][val];
        }
      }

      // return themes[this.thematicField][val] || null;
      // return style;
      return fillcolor;
    }
  }

  /* called from ModifyVectorFeature.js:deselect() */
  function setThematicStyle(val, style) {
    themes[this.thematicField][val] = style;
  }

  return {
    getThematicField: getThematicField,
    setThematicField: setThematicField,
    // getThematicStyle: getThematicStyle,
    getThematicFillColor: getThematicFillColor,
    setThematicStyle: setThematicStyle
  };

}
